import React from 'react';
import i18next from 'i18next';
import { DateFormatter } from 'components/AppTable/CellsComponents';

const formatOptionalText = value => value || '—';

const getTableConfig = ({ showCompanyColumn = false } = {}) => {
  const columns = [
    {
      title: i18next.t('tablesLabels.date'),
      field: 'occurredAt',
      columnWidth: '180px',
      isSorting: true,
      Component: value => <DateFormatter value={value} format="MM/DD/YYYY LT" />,
    },
    {
      title: i18next.t('tablesLabels.eventName'),
      field: 'eventName',
      columnWidth: '240px',
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.eventType'),
      field: 'eventType',
      columnWidth: '140px',
      isSorting: true,
    },
    {
      title: i18next.t('tablesLabels.sourceEntity'),
      field: 'sourceEntity',
      columnWidth: '140px',
    },
    {
      title: i18next.t('tablesLabels.sourceEntityId'),
      field: 'sourceEntityId',
      columnWidth: '100px',
      alignment: 'center',
    },
  ];

  if (showCompanyColumn) {
    columns.push({
      title: i18next.t('tablesLabels.company'),
      field: 'companyName',
      columnWidth: '160px',
    });
  }

  columns.push(
    {
      title: i18next.t('tablesLabels.user'),
      field: 'user',
      columnWidth: '160px',
      Component: formatOptionalText,
    },
    {
      title: i18next.t('tablesLabels.actor'),
      field: 'actor',
      columnWidth: '160px',
      Component: formatOptionalText,
    },
    {
      title: '',
      field: 'id',
      isVisible: false,
    },
  );

  return columns;
};

export default getTableConfig;
